export default __webpack_public_path__ + "static/media/1978.0d5d467c.png";